import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {} from '@fortawesome/fontawesome-svg-core'
import {
    faBars,
    faLaptopCode,
    faArrowCircleLeft,
    faUserCircle,
    faArrowCircleRight,
    faUser,
    faClipboard,
    faCheck,
    faPlay,
    faPrint,
    faFileMedical,
    faUsers,
    faFileInvoice,
    faMoneyCheckAlt,
    faEye,
    faEyeSlash,
    faPlusCircle,
    faArrowsAlt,
    faArrowsAltV,
    faChevronUp,
    faChevronDown,
    faArrowRight,
    faEnvelopeOpenText,
    faQuestionCircle,
    faInfoCircle,
    faSearch,
    faCheckCircle,
    faExclamationCircle,
    faExclamation,
    faTasks,
    faCircle,
    faSpinner,
    faQuestion
} from '@fortawesome/free-solid-svg-icons'

import {} from '@fortawesome/free-brands-svg-icons'


library.add(
    faBars,
    faLaptopCode,
    faArrowCircleLeft,
    faUserCircle,
    faArrowCircleRight,
    faClipboard,
    faCheck,
    faPlay,
    faPrint,
    faFileMedical,
    faUsers,
    faFileInvoice,
    faMoneyCheckAlt,
    faEye,
    faEyeSlash,
    faPlusCircle,
    faArrowsAlt,
    faArrowsAltV,
    faChevronUp,
    faChevronDown,
    faArrowRight,
    faEnvelopeOpenText,
    faQuestionCircle,
    faInfoCircle,
    faSearch,
    faCheckCircle,
    faExclamationCircle,
    faExclamation,
    faTasks,
    faCircle,
    faSpinner,
    faUser,
    faQuestion
)

export {
    FontAwesomeIcon
}